module.exports = __webpack_public_path__ + "static/media/RightBu.5aedb0e8.svg";